const path = require('path');

const RESPONSE_POOL = [];
const POOL_SIZE = 1000;

class FullstxResponse {
    constructor() {
        this.raw = null;
        this.req = null;
        this.route = null;
    }

    init(rawRes, req) {
        this.raw = rawRes;
        this.req = req;
        this.route = null;
    }

    get statusCode() {
        return this.raw.statusCode;
    }
    set statusCode(val) {
        this.raw.statusCode = val;
    }

    get headersSent() {
        return this.raw.headersSent;
    }

    setHeader(name, value) {
        this.raw.setHeader(name, value);
        return this;
    }

    getHeader(name) {
        return this.raw.getHeader(name);
    }

    removeHeader(name) {
        this.raw.removeHeader(name);
        return this;
    }

    writeHead(statusCode, headers) {
        this.raw.writeHead(statusCode, headers);
        return this;
    }

    write(chunk, encoding, callback) {
        return this.raw.write(chunk, encoding, callback);
    }

    end(data, encoding, callback) {
        return this.raw.end(data, encoding, callback);
    }

    on(event, listener) {
        this.raw.on(event, listener);
        return this;
    }

    status(code) {
        this.raw.statusCode = code;
        return this;
    }

    json(data, statusCode = 200) {
        this.raw.writeHead(statusCode, { 'Content-Type': 'application/json' });
        if (this.route && this.route.serializer) {
            this.raw.end(this.route.serializer(data));
        } else {
            this.raw.end(JSON.stringify(data));
        }
    }

    html(htmlStr, statusCode = 200) {
        this.raw.writeHead(statusCode, { 'Content-Type': 'text/html' });
        this.raw.end(htmlStr);
    }

    render(viewPath, data = {}) {
        const ejs = require('ejs');
        const fullPath = path.isAbsolute(viewPath) ? viewPath : path.join(process.cwd(), 'views', viewPath);
        ejs.renderFile(fullPath, data, (err, str) => {
            if (err) {
                this.raw.writeHead(500, { 'Content-Type': 'text/plain' });
                this.raw.end('Template rendering error: ' + err.message);
            } else {
                this.html(str);
            }
        });
    }

    sse(data, event = 'message') {
        if (!this.raw.headersSent) {
            this.raw.writeHead(200, {
                'Content-Type': 'text/event-stream',
                'Cache-Control': 'no-cache',
                Connection: 'keep-alive'
            });
        }
        this.raw.write(`event: ${event}\n`);
        this.raw.write(`data: ${typeof data === 'object' ? JSON.stringify(data) : data}\n\n`);
    }

    redirect(url, statusCode = 302) {
        this.raw.writeHead(statusCode, { Location: url });
        this.raw.end();
    }

    header(key, value) {
        this.raw.setHeader(key, value);
        return this;
    }

    cookie(name, value, options = {}) {
        let cookieString = `${name}=${encodeURIComponent(value)}`;
        if (options.maxAge) cookieString += `; Max-Age=${options.maxAge}`;
        if (options.domain) cookieString += `; Domain=${options.domain}`;
        if (options.path) cookieString += `; Path=${options.path}`;
        if (options.expires) cookieString += `; Expires=${options.expires.toUTCString()}`;
        if (options.httpOnly) cookieString += `; HttpOnly`;
        if (options.secure) cookieString += `; Secure`;
        if (options.sameSite) cookieString += `; SameSite=${options.sameSite}`;

        let existing = this.raw.getHeader('Set-Cookie');
        if (!existing) {
            existing = [];
        } else if (!Array.isArray(existing)) {
            existing = [existing];
        }
        existing.push(cookieString);
        this.raw.setHeader('Set-Cookie', existing);
        return this;
    }

    send(body) {
        if (typeof body === 'object' && body !== null && !Buffer.isBuffer(body)) {
            return this.json(body);
        }
        if (typeof body === 'string') {
            if (!this.raw.getHeader('Content-Type')) {
                this.raw.setHeader('Content-Type', 'text/html');
            }
        }
        this.raw.end(body);
    }
}

function getResponse(rawRes, req) {
    if (RESPONSE_POOL.length > 0) {
        const res = RESPONSE_POOL.pop();
        res.init(rawRes, req);
        return res;
    }
    const res = new FullstxResponse();
    res.init(rawRes, req);
    return res;
}

function releaseResponse(res) {
    res.raw = null;
    res.req = null;
    res.route = null;

    if (RESPONSE_POOL.length < POOL_SIZE) {
        RESPONSE_POOL.push(res);
    }
}

module.exports = {
    FullstxResponse,
    getResponse,
    releaseResponse
};
